import PropTypes from "prop-types"
import React from "react"
import { Col, Modal, ModalBody, Row, Spinner } from "reactstrap"

const ConfirmModal = ({ show, onConfirmClick, onCloseClick, loading }) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center">
              <i
                className="mdi mdi-alert-circle-outline"
                style={{ fontSize: "9em", color: "orange" }}
              />
              <h2>Are you sure?</h2>
            </div>
          </Col>
        </Row>
        <Row>
          {loading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spinner type="grow" className="m-1 center" color="primary" />
            </div>
          ) : (
            <Col>
              <div className="text-center mt-3">
                <button
                  type="button"
                  className="btn btn-success btn-lg ms-2"
                  onClick={onConfirmClick}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-lg ms-2"
                  onClick={onCloseClick}
                >
                  Cancel
                </button>
              </div>
            </Col>
          )}
        </Row>
      </ModalBody>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  onCloseClick: PropTypes.func,
  onConfirmClick: PropTypes.func,
  show: PropTypes.any,
}

export default ConfirmModal
